import type { IFramework } from '@/framework';
import { getSmartGuidesStore } from './states/smart-guides-state';
import type { SmartGuideBlock, SmartGuideLine, SmartGuidesState } from './types';

/** 智能参考线插件实例 */
export class SmartGuidesPlugin {
    /** registration 中稳定的实例键。 */
    static readonly instanceName = 'SmartGuidesPlugin';

    /** 用于隔离不同编辑器的 smart-guides 状态。 */
    private readonly identity: string;

    constructor(identity: string) {
        this.identity = identity;
    }

    /** 从编辑器框架中按需获取插件实例 */
    static get(framework: IFramework): SmartGuidesPlugin | undefined {
        return framework.service.registration.getInstance<SmartGuidesPlugin>(SmartGuidesPlugin.instanceName);
    }

    /** 获取当前智能参考线状态 */
    getState = (): SmartGuidesState => getSmartGuidesStore(this.identity).getState().snapshot;

    /** 设置智能参考线 */
    setLines(lines: readonly SmartGuideLine[]) {
        getSmartGuidesStore(this.identity).getState().setLines(lines);
    }

    /** 设置等间距提示区域 */
    setBlocks(blocks: readonly SmartGuideBlock[]) {
        getSmartGuidesStore(this.identity).getState().setBlocks(blocks);
    }

    /** 清空智能参考线和等间距提示区域 */
    clear() {
        getSmartGuidesStore(this.identity).getState().clear();
    }

    /** 监听智能参考线状态变化 */
    onChange = (callback: () => void) =>
        getSmartGuidesStore(this.identity).subscribe((state, previousState) => {
            if (state.snapshot !== previousState.snapshot) callback();
        });
}
